import { useQuery } from '@tanstack/react-query';

import { useApplication } from '@bonusly/application';

import { createHttpClient } from '../lib';

const QUERY_KEY = 'spoofing';

interface SpoofingResponse {
	success: string;
	result: {
		is_spoofing: boolean;
		is_demoing: boolean;
	};
}

export const useSpoofing = () => {
	const baseURL = useApplication.getState().application.recognizeOrigin;
	const http = createHttpClient(baseURL);
	const { data, isLoading } = useQuery([QUERY_KEY], () => http.get<SpoofingResponse>('/api/v2/spoofing'), {
		select: (data) => data.data.result,
		refetchInterval: Infinity,
	});
	return {
		isSpoofing: data?.is_spoofing,
		isDemoing: data?.is_demoing,
		isLoading,
	};
};
